// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Campaign_wrapper__3-OZv"};